var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ripa-label',{class:[_vm.noMargins ? null : 'tw-my-4'],attrs:{"value":_vm.text,"bold":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }